import { render, staticRenderFns } from "./SidebarRightApp.vue?vue&type=template&id=6c96ebe1&"
import script from "./SidebarRightApp.vue?vue&type=script&lang=js&"
export * from "./SidebarRightApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports